import { RBTM } from '@/constants';

export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  detail: (state) => state.detail,
  rules: (state) => state.rules,
  statuses: (state) => state.statuses,
  types: (state) => state.types,
  isOpen: (state) => {
    const status = state.statuses.find(
      (s) => s.id === state?.detail?.transaction_state_id,
    );
    return status && status.state_key
      ? status.state_key === RBTM.STATES.HANDLING
      || status.state_key === RBTM.STATES.PENDING
      : false;
  },
  isSent: (state) => {
    return state.detail?.individual_id_wallet === state.detail?.from_wallet;
  },
};
